var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-pag-container"},[_c('div',{staticClass:"back-info"},[_c('div',{staticClass:"content"},[_vm._v(" 您所寻找的页面不存在，你可以点击下面的按钮，返回主页 ")]),_c('el-button',{staticClass:"custom-btn",attrs:{"type":"primary"},on:{"click":_vm.enterProjectList}},[_vm._v(" 返回首页 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }